export default __webpack_public_path__ + "static/banner-bg-751edc0e3d555b3882bd1f3a4f75cb31.png";